import {
  fetchStatsByKeyActionBuilder,
  subscribeStatsActionBuilder,
  unsubscribeStatsActionBuilder,
  fetchStatsByWildCardActionBuilder,
} from '@ahaslides-product/frontend-toolkit'
import kvSyncApi from '@/api/kvSync'
import { liveStats } from '@/mqtt/liveStats'
import config from '@/config'

const actions = {
  fetchStatsByKeyAction: fetchStatsByKeyActionBuilder(kvSyncApi, config),
  fetchStatsByWildCardAction: fetchStatsByWildCardActionBuilder(kvSyncApi, config),
  subscribeStatsAction: subscribeStatsActionBuilder(liveStats),
  unsubscribeStatsAction: unsubscribeStatsActionBuilder(liveStats),
}

export default actions
